/**
 * Tile source for the birthplace map (BirthplacePicker).
 *
 * OSM's public tile server is for osm.org and hobby use; its usage policy
 * forbids distributing an app on it, and prod got cut off ("403 Access
 * blocked: App is not following the OSM tile usage policy"). MapTiler serves
 * the same OSM data behind a key that is restricted to our origins, so it is
 * safe to ship in public config. With no key -- a dev box -- the map still
 * reads from OSM, which is within their policy for a developer at a laptop.
 *
 * MapTiler checks that restriction against the Referer, and the host serves
 * the app with Referrer-Policy: same-origin, which strips it from every
 * cross-origin request -- prod's first keyed map was a grid of "Invalid key"
 * tiles. So each tile image carries its own policy: send our origin, nothing
 * more. Leaflet takes it as an option; OpenLayers through its load hook.
 */

const MAPTILER_STYLE = 'streets-v2-dark'   // the modal is night-purple; a pale map glared
const TILE_REFERRER = 'strict-origin-when-cross-origin'

function loadTileWithOrigin(tile, src) {
  const img = tile.getImage()
  img.referrerPolicy = TILE_REFERRER
  img.src = src
}

export function tileSource(key) {
  const k = (key || '').trim()
  if (!k) {
    return {
      keyed: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &middot; GeoNames',
      },
    }
  }
  return {
    keyed: true,
    url: `https://api.maptiler.com/maps/${MAPTILER_STYLE}/{z}/{x}/{y}.png?key=${encodeURIComponent(k)}`,
    options: {
      maxZoom: 18,
      attribution: '<a href="https://www.maptiler.com/copyright/">&copy; MapTiler</a> '
        + '<a href="https://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a> &middot; GeoNames',
      referrerPolicy: TILE_REFERRER,
      tileLoadFunction: loadTileWithOrigin,
    },
  }
}
